
import MaterialDivider from '@material-ui/core/Divider';
import React, { Component } from 'react';

class Divider extends Component {
  render() {
    return (
      <MaterialDivider {...this.props} />
    );
  }
}

export default Divider;



// WEBPACK FOOTER //
// ./src/app/components/divider/divider.js